module.exports = __webpack_public_path__ + "img/shop_area_4.89041202.jpg";